import { gql } from "@grandvisionhq/graphql";
const createApplePaySessionResult = gql`
  fragment CreateApplePaySessionResultFragment on ApplePaySession {
    data
    __typename
  }
`;
export {
  createApplePaySessionResult
};
//# sourceMappingURL=create-apple-pay-session-mutation-result.js.map
